//Utilities
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var _ = require('lodash');
var Formatter = require('../utils/Formatter.js');
var ContentService = require('../services/ContentService.js');
//Component
var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/SuperFirstTransferConstant.js');
var ApplicationConstants = require('../constants/ApplicationConstants.js');
var PensionConstants = require ('../constants/PensionTypeConstants.js');
var RollOverTypes = require('../constants/FundingYourProductConstants').RollOverTypes;
var FundTypesLabel = require('../constants/FundingYourProductConstants').FundTypesLabel;
var FundingTypes = require('../constants/FundingYourProductConstants').FundingTypes;
var FundingYourProductActionTypes = require('../constants/FundingYourProductConstants').ActionTypes;
var Monies = require('../constants/FundingYourProductConstants');
var Contributions = require('../constants/FundingYourProductConstants').OnlyContributions;
var FundingYourProductStore = require('../stores/FundingYourProductStore');
//local variables
var ActionTypes = Constants.ActionTypes;
var ApplicationActionTypes = ApplicationConstants.ActionTypes;
var PensionActionTypes = PensionConstants.ActionTypes;
var CHANGE_EVENT = 'change';
var _nonInternalRollOvers = [];
var _isExternalRollOverOnly = false;
var _isInternalExternalRollOver = false;
var _isInternalAndInternalRollOver = false;
var _isMoniesWithExternal = false
var _isInternalExternalRollOverForAPI = false;
var _isInternalMoniesExternalMoniesForAPI = false;
var _isAdviceFeeOneOffExist = false;
var _externalRollOvers = [];
var _allSummary = [];
var _crossSectionDependencyMsg = [];
var _model = {
    isSuperTransferSetup: ApplicationConstants.YesNoValues.NO
}
var _isDeathBenefit = false;
var _isIntExtWithMonies = false;
var _isRetirementBenefit =false;

let _productId;

function setProductId(productId) {
    _productId = productId;
}

function updateSuperFirstData(fieldName, value) {
    _model[fieldName] = value;
    updateCrossSectionDependencyMsg();
}

function updateSuperFirst(data){
    if(_isInternalExternalRollOver || _isInternalAndInternalRollOver) {
        _model.isSuperTransferSetup =(data.inSpecieModel && data.inSpecieModel.setUp && data.inSpecieModel.setUp === ApplicationConstants.YesNoValues.YES)? ApplicationConstants.YesNoValues.NO:ApplicationConstants.YesNoValues.YES;
    }  
}

function updateIsAdviceFeeOneOffExist(isExist)
{
    _isAdviceFeeOneOffExist = isExist;
}

function updateCrossSectionDependencyMsg() {
    _crossSectionDependencyMsg = [];
    if (ApplicationConstants.FormModel.form.adviceFee.adviceFeeOption === ApplicationConstants.YesNoValues.YES && _isAdviceFeeOneOffExist) {
        _crossSectionDependencyMsg.push({content: ContentService.getContent().crossSectionHeaders.adviceFees, order: 1});
    }
}


function setSummaryData(summary) {
    var wasYesNoOptionShown = _nonInternalRollOvers.length > 0 && _isExternalRollOverOnly;
    var summaryTemp = _.cloneDeep(summary);
    _allSummary = _.cloneDeep(summary);

    setIsInternalWithExternalRollOver(summary);
    setIsInternalMoniesWithExternalMonies(summary);

    summaryTemp = summaryTemp.filter(function (o) {
        return o.rollOverType !== RollOverTypes.INTERNAL
    });

    setIsExternalRollOversOnly(summaryTemp);
    
    _nonInternalRollOvers = summaryTemp;

    var toShowYesNoOption = _nonInternalRollOvers.length > 0 && _isExternalRollOverOnly;
    var isSuperTransferSetup = _model.isSuperTransferSetup;
    if (_nonInternalRollOvers.length > 0 || _isInternalAndInternalRollOver) {
        // to show section
        if (_isInternalExternalRollOver || _isInternalAndInternalRollOver) {
        isSuperTransferSetup = ApplicationConstants.YesNoValues.YES;
        }
        else if (_isExternalRollOverOnly) {
            // External without contribution: only reset if YesNoOption had not been displayed before the funding summary changed
            if (!wasYesNoOptionShown && toShowYesNoOption) {
                isSuperTransferSetup = ApplicationConstants.YesNoValues.NO;
            }
        } else {
            // Contribution exists               
            isSuperTransferSetup = ApplicationConstants.YesNoValues.YES;        
    }
    } else {
        // to hide section
        isSuperTransferSetup = ApplicationConstants.YesNoValues.NO;
    }

    if (isSuperTransferSetup !== _model.isSuperTransferSetup) {
        updateCrossSectionDependencyMsg();
        _model.isSuperTransferSetup = isSuperTransferSetup;
    }
}

function getRolloverTypes() {
    var fundingSources = '';
    var comma = '';
    var rollover = '';
    //process external rollovers
    for (var i = 0; i < _externalRollOvers.length; i++) {
        if (i > 0) {
            comma = ', ';
        }
        rollover = _externalRollOvers[i].rollOverNamePredictive ? _externalRollOvers[i].rollOverNamePredictive : _externalRollOvers[i].rollOverName;
        fundingSources = fundingSources + comma + rollover;
    }

    //check if each contribution type exists
    var personalExists = _.where(_nonInternalRollOvers, { rollOverType: FundingTypes.Personal_contribution }).length > 0;
    var spouseExists = _.where(_nonInternalRollOvers, { rollOverType: FundingTypes.Spouse_contribution }).length > 0;
    var cgtExists = _.where(_nonInternalRollOvers, { rollOverType: FundingTypes.CGT_contribution }).length > 0;
    var injuryExists = _.where(_nonInternalRollOvers, { rollOverType: FundingTypes.Personal_injury_payment }).length > 0;
    var downsizerExists = _.where(_nonInternalRollOvers, { rollOverType: FundingTypes.Downsizer_contribution}).length > 0;

    //add them if they exist (order is specific, personal, spouse, cgt, injury and downsizer)
    fundingSources = getContributionTypes(fundingSources, personalExists, FundingTypes.Personal_contribution);
    fundingSources = getContributionTypes(fundingSources, spouseExists, FundingTypes.Spouse_contribution);
    fundingSources = getContributionTypes(fundingSources, cgtExists, FundingTypes.CGT_contribution);
    fundingSources = getContributionTypes(fundingSources, injuryExists, FundingTypes.Personal_injury_payment);
    fundingSources = getContributionTypes(fundingSources, downsizerExists, FundingTypes.Downsizer_contribution);
    return fundingSources;
}

function getContributionTypes(fundingSources, doesExist, contributionType) {
    if (doesExist) {
        var comma = '';
        if (fundingSources.length > 0) {
            comma = ', ';
        }
        fundingSources = fundingSources + comma + FundTypesLabel[contributionType];
    }
    return fundingSources;
}

function setIsExternalRollOversOnly(summary) {
    if (summary.length > 0) {
        _externalRollOvers = _.where(summary, { rollOverType: RollOverTypes.EXTERNAL });
        _isExternalRollOverOnly = _externalRollOvers.length === summary.length;
    }
}

function setIsInternalWithExternalRollOver(summary) {
    var _internalRollOvers = [];
    if (summary.length > 0) {
        var allListData = [];
        allListData = summary;
        _externalRollOvers = _.where(summary, { rollOverType: RollOverTypes.EXTERNAL });

        _internalRollOvers = _.where(summary, { rollOverType: RollOverTypes.INTERNAL });
        if (_internalRollOvers.length > 0) {
            _internalRollOvers = _internalRollOvers.filter(function (o) {
                return _.includes(Monies.InternalMonies, o.rollOverName);
            });
        }
        if (_externalRollOvers.length > 0 && _internalRollOvers.length > 0 && _isRetirementBenefit) {
            _isInternalExternalRollOver = true;

            if (_isInternalExternalRollOver) {
                var intExtWithMonies = allListData.filter(function (o) {
                    return _.includes(Monies.ExternalMomies, o.rollOverName);
                });
                _isIntExtWithMonies = intExtWithMonies.length > 0 ? true : false;
                _isInternalExternalRollOverForAPI = _externalRollOvers.length > 0 && _internalRollOvers.length > 0 && intExtWithMonies.length < 1;                               
            }
        }
        else {
            _isInternalExternalRollOver = false;
        }
    }
}

function setIsInternalMoniesWithExternalMonies(summary) {
    var inspecieRollOvers = [];
    var externalMoniesRollOvers = [];
    var allInternalRollOvers = [];
    if (summary.length > 0)
    {
        _externalRollOvers = _.where(summary, { rollOverType: RollOverTypes.EXTERNAL });
        allInternalRollOvers = _.where(summary, { rollOverType: RollOverTypes.INTERNAL });        
         if(allInternalRollOvers.length > 0)
         {
            inspecieRollOvers = allInternalRollOvers.filter(function (o) {
                return _.includes(Monies.InternalMonies, o.rollOverName);
            });

            externalMoniesRollOvers = allInternalRollOvers.filter(function (o) {
                return _.includes(Monies.ExternalMomies, o.rollOverName);
            });

            _isInternalAndInternalRollOver = inspecieRollOvers.length > 0 && externalMoniesRollOvers.length > 0  && _isRetirementBenefit? true : false;
            _isMoniesWithExternal = _isInternalAndInternalRollOver && _externalRollOvers.length > 0 ? true : false;
            _isInternalMoniesExternalMoniesForAPI = _isInternalAndInternalRollOver && _externalRollOvers.length < 1;
        }
    }
    else
    {
        _isInternalAndInternalRollOver=false;
    }
  }

function getExternalMoniesRollOver(_allSummary)
{   
    let _allInternalRolloverData = [];
    let _internalRollOvers = [];
    var onlyInternal = '';

    _allInternalRolloverData = _allSummary;    

    _internalRollOvers = _allInternalRolloverData.filter(function (o) {
        return o.rollOverType === RollOverTypes.INTERNAL
    });

    if (_internalRollOvers.length > 0) {

        onlyInternal = _internalRollOvers.map(function (o) {
            if (onlyInternal === '' || onlyInternal === null) {
                return o.rollOverName;
            } else { return onlyInternal + ', ' + o.rollOverName; }
        });

    }
    return onlyInternal;
}

function getSelectedExternalMonies(internalRollover)
{      
    let selectedMonies= '';
    let moniesinInternalRoll = [];
    moniesinInternalRoll = _.includes(internalRollover, ',') ? internalRollover.trim().split(',') : internalRollover;
    if(moniesinInternalRoll.length > 0){
        moniesinInternalRoll = moniesinInternalRoll.filter((word) => _.includes(Monies.ExternalMomies,word));
        selectedMonies= moniesinInternalRoll.join(',');
    }
    return  selectedMonies;
}

function getSuperfirstMessagDetails(rolloverName){
    let content = ContentService.getContent();
    let superFirstMsg={};
    
    superFirstMsg.downsizerContributionNotice = !FundingYourProductStore.getDownsizerContributionSwitch().killSwitch ? (content.yourDetails[_productId] && content.yourDetails[_productId].downsizerContributionNotice) : null;
    superFirstMsg.sftInlineMessageRollover = Formatter.formatString(content.superFirstTransfer.sftInlineMessageRolloverTypes, { rolloverType: rolloverName });
    superFirstMsg.sftInlineMessageLink = content.superFirstTransfer.sftInlineMessageLink;

    return superFirstMsg;
}

function removeFromSummary(index) {
    if (index > -1) {
        _allSummary.splice(index, 1);
    }
}

function retrieveSuperFirstModel(form) {
    if (form.superFirstTransfer && form.fundingYourProduct.fundingSources) {
        var summaryTemp = _.cloneDeep(form.fundingYourProduct.fundingSources);
        
        setIsInternalWithExternalRollOver(summaryTemp);
        setIsInternalMoniesWithExternalMonies(summaryTemp);
        summaryTemp = summaryTemp.filter(function (o) {
            return o.rollOverType !== RollOverTypes.INTERNAL
        });

        setIsExternalRollOversOnly(summaryTemp);
        _nonInternalRollOvers = summaryTemp;
        
        _model.isSuperTransferSetup = form.superFirstTransfer.isSuperTransferSetup === ApplicationConstants.isTrue ? ApplicationConstants.YesNoValues.YES : ApplicationConstants.YesNoValues.NO;
    }
}

function sortCrossSectionOrder() {
    _crossSectionDependencyMsg = _.sortBy(_crossSectionDependencyMsg, 'order');
}

function pensionTypeChanged(pensionType) {
    _isDeathBenefit = pensionType === PensionConstants.PensionTypeBenefits.ENTRY_DEATH;
      _isRetirementBenefit   = pensionType === PensionConstants.PensionTypeSelectionNames.RETIREMENT || pensionType === PensionConstants.PensionTypeBenefits.ENTRY_RETIREMENT_RETIRED_PRESERVE_AGE || pensionType === PensionConstants.PensionTypeBenefits.ENTRY_RETIREMENT_RETIRED_PRE65; 
    if(!_isRetirementBenefit) 
    {
        _isInternalExternalRollOver = false;
        _isInternalAndInternalRollOver = false;
    }                              
    if (_isDeathBenefit) {
        _allSummary = [];
    }
}

var SuperFirstTransferStore = assign({}, EventEmitter.prototype, {

    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    addChangeListener: function (callback) {
        this.on(CHANGE_EVENT, callback);
    },

    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },

    getModel: function () {
        return _model;
    },

    getSuperFirstModel: function () {
        return _model.isSuperTransferSetup;
    },

    getNonInternalRollovers: function () {
        return _nonInternalRollOvers;
    },

    getIsExternalRollOversOnly: function () {
        return _isExternalRollOverOnly;
    },

    
    getIsInternalExternalRollOversOnly: function () {
        return _isInternalExternalRollOver;
    },

    getIsInternalMoniesExternalMonies: function () {
        return _isInternalAndInternalRollOver;
    },

    getFormModel: function () {
        let sftInlineMessageRollover = '';
        let sftInlineMessageLink = '';
        let downsizerContributionNotice = '';
        let selectedMoniesRollover = ''
        let isContribution = false;
        let rolloverDetails = [];

        let rolloverTypes = getRolloverTypes();
        if (rolloverTypes.length > 0) {
            rolloverDetails = _.includes(rolloverTypes, ',')? rolloverTypes.split(',').map(s => s.trim()) : rolloverTypes.trim().split();
             isContribution = Contributions.some(r => _.includes(rolloverDetails,r));
        }
        
        if (_nonInternalRollOvers.length > 0 && _model.isSuperTransferSetup === ApplicationConstants.YesNoValues.YES && !_isInternalAndInternalRollOver && !_isInternalExternalRollOver) {
            downsizerContributionNotice = getSuperfirstMessagDetails(rolloverTypes).downsizerContributionNotice;
            sftInlineMessageRollover =  getSuperfirstMessagDetails(rolloverTypes).sftInlineMessageRollover;
            sftInlineMessageLink =  getSuperfirstMessagDetails(rolloverTypes).sftInlineMessageLink;
        }
        if (_isInternalExternalRollOver) {
            let internalRollover = getExternalMoniesRollOver(_allSummary);
            var externalMonies;
          
            if (internalRollover.length > 0) {
               
                selectedMoniesRollover = getSelectedExternalMonies(internalRollover);
                externalMonies = selectedMoniesRollover.length < 1 ? rolloverTypes : rolloverTypes.concat(',').concat(selectedMoniesRollover);
                downsizerContributionNotice = getSuperfirstMessagDetails(externalMonies).downsizerContributionNotice;
                sftInlineMessageRollover =  getSuperfirstMessagDetails(externalMonies).sftInlineMessageRollover;
                sftInlineMessageLink =  getSuperfirstMessagDetails(externalMonies).sftInlineMessageLink;
            }
           else {
            downsizerContributionNotice = getSuperfirstMessagDetails(rolloverTypes).downsizerContributionNotice;
            sftInlineMessageRollover =  getSuperfirstMessagDetails(rolloverTypes).sftInlineMessageRollover;
            sftInlineMessageLink =  getSuperfirstMessagDetails(rolloverTypes).sftInlineMessageLink;
           }
        }
        else{
            if (_isInternalAndInternalRollOver) {
                let internalRollover = getExternalMoniesRollOver(_allSummary);
                if (_externalRollOvers.length > 0 || isContribution) {
                    var monies; 
                    if (internalRollover.length > 0) {
                        selectedMoniesRollover = getSelectedExternalMonies(internalRollover);
                        monies = selectedMoniesRollover.length < 1 ? rolloverTypes : rolloverTypes.concat(',').concat(selectedMoniesRollover);
                        downsizerContributionNotice = getSuperfirstMessagDetails(monies).downsizerContributionNotice;
                        sftInlineMessageRollover = getSuperfirstMessagDetails(monies).sftInlineMessageRollover;
                        sftInlineMessageLink = getSuperfirstMessagDetails(monies).sftInlineMessageLink;
                    }
                   else {
                      downsizerContributionNotice = getSuperfirstMessagDetails(rolloverTypes).downsizerContributionNotice;
                      sftInlineMessageRollover = getSuperfirstMessagDetails(rolloverTypes).sftInlineMessageRollover;
                      sftInlineMessageLink = getSuperfirstMessagDetails(rolloverTypes).sftInlineMessageLink;
                   }
                }
                else {
                    var internalMonies;
                    internalMonies = getSelectedExternalMonies(internalRollover);
                    downsizerContributionNotice = getSuperfirstMessagDetails(internalMonies).downsizerContributionNotice;
                    sftInlineMessageRollover = getSuperfirstMessagDetails(internalMonies).sftInlineMessageRollover;
                    sftInlineMessageLink = getSuperfirstMessagDetails(internalMonies).sftInlineMessageLink;
                }
            }
        }
        
        var formModel = {
            isSuperTransferSetup: _model.isSuperTransferSetup,
            ShowSuperFastForInternals: _isInternalAndInternalRollOver,
            IsInternalWithExternalCase: _isInternalExternalRollOverForAPI,
            IsIntExtWithMonies: _isIntExtWithMonies,
            IsInternalWithInternalCase: _isInternalMoniesExternalMoniesForAPI,
            IsInternalsWithExternal: _isMoniesWithExternal,
            nonInternalExists: _nonInternalRollOvers.length > 0,
            sftInlineMessageRollover: sftInlineMessageRollover,
            sftInlineMessageLink: sftInlineMessageLink,
            isDeathBenefit: _isDeathBenefit,
            isRetirementBenefit: _isRetirementBenefit,
            downsizerContributionNotice
        }
        return formModel;
    },

    getCrossSectionDependencyMsg() {
        sortCrossSectionOrder();
        return _crossSectionDependencyMsg;
    }
});

SuperFirstTransferStore.dispatchToken = AppDispatcher.register(function (action) {

    switch (action.actionType) {
        case ApplicationActionTypes.IS_FUNDING_SUMMARY:
            setSummaryData(action.summary);
            break;
        case ActionTypes.UPDATE_SUPER_FIRST_DATA:
            updateSuperFirstData(action.fieldName, action.value);
            break;
        case ActionTypes.UPDATE_IS_ADVICE_FEE_ONEOFF_EXIST:
            updateIsAdviceFeeOneOffExist(action.isExist);
            break;
        case FundingYourProductActionTypes.DELETE_FUNDING_TYPE:
            removeFromSummary(action.index);
            break;
        case ApplicationConstants.ActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            setProductId(action.applicationData.productId);
            retrieveSuperFirstModel(action.applicationData.form);
            break;
        case ApplicationConstants.ActionTypes.SET_PRODUCT_ID:
            setProductId(action.productId);
            break;
        case PensionActionTypes.SELECT_BENEFIT:
        case PensionActionTypes.SELECT_PENSION_TYPE:
            pensionTypeChanged(action.value);
            break;
        case ApplicationConstants.ActionTypes.SEND_INSPECIE_DATA:
            updateSuperFirst(action.data);
            break;
        default:
            return true;
    }
    SuperFirstTransferStore.emitChange();
    return true;
});

export default SuperFirstTransferStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/SuperFirstTransferStore.js